import { render, staticRenderFns } from "./SponsorDetails.vue?vue&type=template&id=5d4ac273&"
import script from "./SponsorDetails.vue?vue&type=script&lang=js&"
export * from "./SponsorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports